import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../css/QuestionHub.css";
import questionsData from "../data/questions.json";

const subcategoriesMap = {
  science: ["All", "Physics", "Biology", "Chemistry", "Earth Science", "Environmental Science"],
  technology: ["All", "Information Technology", "Software Development", "Robotics", "Digital Media", "Artificial Intelligence"],
  engineering: ["All", "Civil Engineering", "Mechanical Engineering", "Electrical Engineering", "Chemical Engineering", "Software Engineering"],
  math: ["All", "Algebra", "Geometry", "Calculus", "Statistics", "Probability", "Mathematical Modeling"]
};

const QuestionHub = () => {
  const { category } = useParams();
  const navigate = useNavigate();

  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const searchInputRef = useRef(null);

  useEffect(() => {
    const categoryQuestions = questionsData.filter((q) => q.category === category);
    setFilteredQuestions(categoryQuestions);
    setSelectedSubcategory("All");
    setSearchQuery("");
    setShowSearch(false);
  }, [category]);

  useEffect(() => {
    let categoryQuestions = questionsData.filter((q) => q.category === category);

    if (selectedSubcategory !== "All") {
      categoryQuestions = categoryQuestions.filter(
        (q) => q.subcategory === selectedSubcategory
      );
    }

    if (searchQuery.trim() !== "") {
      const keyword = searchQuery.toLowerCase();
      categoryQuestions = categoryQuestions.filter(
        (q) =>
          q.title.toLowerCase().includes(keyword) ||
          q.author.toLowerCase().includes(keyword) ||
          q.subcategory?.toLowerCase().includes(keyword)
      );
    }

    setFilteredQuestions(categoryQuestions);
  }, [searchQuery, selectedSubcategory, category]);

  const handleSubcategoryChange = (e) => {
    setSelectedSubcategory(e.target.value);
  };

  const handleCardClick = (question) => {
    navigate(`/show-question/${question.id}`, { state: { image: question.image } });
  };

  const toggleSearch = () => {
    setShowSearch(!showSearch);
    if (!showSearch) {
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 100);
    }
  };

  return (
    <div className="question-hub" data-category={category}>

      <div className="back-button-wrapper">
        <button className="back-button" onClick={() => navigate("/")}>
          ＜ Back
        </button>
      </div>

      <h2>{category.charAt(0).toUpperCase() + category.slice(1)} Questions</h2>

      <div className="filter-search-wrapper">
        <div className="filter-bar-inline">
          <label htmlFor="subcategory">Filter by Subcategory: </label>
          <select
            id="subcategory"
            value={selectedSubcategory}
            onChange={handleSubcategoryChange}
          >
            {subcategoriesMap[category].map((sub) => (
              <option key={sub} value={sub}>
                {sub}
              </option>
            ))}
          </select>

          <button
            className="search-icon-button"
            onClick={toggleSearch}
            aria-label="Toggle Search"
          >
            🔍
          </button>
        </div>

        {showSearch && (
          <div className="search-bar-dropdown">
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Search by title, author, or subcategory..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onBlur={() => setShowSearch(false)}
            />
          </div>
        )}
      </div>

      <div className="question-grid">
        {filteredQuestions.map((q) => (
          <div key={q.id} className="question-card" onClick={() => handleCardClick(q)}>
            <img src={q.image} alt={q.title} />
            <h4>{q.title}</h4>
            <p>By {q.author}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuestionHub;
